import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const SubscriptionContext = createContext();

export const SubscriptionProvider = ({ children }) => {
  const [email, setEmail] = useState(localStorage.getItem("email") || "");
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [loading, setLoading] = useState(true);

  const fetchSubscriptionStatus = async () => {
    setLoading(true);
    try {
      if (!email) {
        console.warn("No email provided");
        setIsSubscribed(false);
        return;
      }

      const url = `https://shubhjiwan.co.in/ShubhJiwan_backend11/check_subscription.php?email=${email}`;
      const res = await axios.get(url);

      console.log("Fetched subscription raw data:", res.data);

      const isSub = res.data?.isSubscribed;
      console.log("Parsed isSubscribed:", isSub, "Type:", typeof isSub);

      setIsSubscribed(isSub === true);
    } catch (err) {
      console.error("Error checking subscription:", err);
      setIsSubscribed(false);
    } finally {
      setLoading(false);
    }
  };

  // Run when email changes
  useEffect(() => {
    fetchSubscriptionStatus();
  }, [email]);

  // Call this whenever user logs in or switches accounts
  const updateEmail = (newEmail) => {
    localStorage.setItem("email", newEmail);
    setEmail(newEmail);
  };

  return (
    <SubscriptionContext.Provider
      value={{ isSubscribed, loading, updateEmail }}
    >
      {children}
    </SubscriptionContext.Provider>
  );
};

export const useSubscription = () => useContext(SubscriptionContext);
